import Swiper from "@theme/swiper";
import { Navigation } from "@theme/swiper-modules";
export default class VariantSelector extends HTMLElement {
  constructor() {
    super();

    this.variants = JSON.parse(
      document.querySelector("#product-variants")?.textContent || "{}",
    );
    this.idInput = this.closest("form")?.querySelector("input[name='id']");
    this.selectors = this.querySelectorAll("input[type='radio']");
    this.optionsCarousel1 = this.querySelector(".option__carousel-1");
    this.optionsCarousel2 = this.querySelector(".option__carousel-2");
    this.optionsCarousel3 = this.querySelector(".option__carousel-3");
    this.legendsOnlySection = document.querySelector("#legends-only-section");
    this.hasTabsVariantMetafields = document.querySelector(
      "[data-tabs-variant-metafields]",
    );
    this.hasLabelsVariantMetafields = document.querySelector(
      "[data-labels-variant-metafields]",
    );
  }

  get sectionId() {
    return this.getAttribute("data-section-id");
  }

  connectedCallback() {
    this.handleChange = this.handleChange.bind(this);

    this.selectors.forEach((selector) => {
      selector.addEventListener("change", this.handleChange);
    });
    this.initOptionsCarousels();
  }

  disconnectedCallback() {
    this.selectors.forEach((selector) => {
      selector.removeEventListener("change", this.handleChange);
    });
  }

  initOptionsCarousels() {
    this.optionsCarousel1 = new Swiper(this.optionsCarousel1, {
      slidesPerView: "auto",
      spaceBetween: 8,
      loop: false,
      modules: [Navigation],
      navigation: {
        prevEl: document.querySelector(".option__carousel-1__prev"),
        nextEl: document.querySelector(".option__carousel-1__next"),
      },
      breakpoints: {
        1024: {
          spaceBetween: 10,
        },
        1800: {
          spaceBetween: 12,
        },
      },
    });
    this.optionsCarousel2 = new Swiper(this.optionsCarousel2, {
      slidesPerView: "auto",
      slidesPerGroup: 1,
      spaceBetween: 8,
      loop: false,
      modules: [Navigation],
      navigation: {
        prevEl: document.querySelector(".option__carousel-2__prev"),
        nextEl: document.querySelector(".option__carousel-2__next"),
      },
      breakpoints: {
        1024: {
          spaceBetween: 10,
        },
        1800: {
          spaceBetween: 12,
        },
      },
    });
  }

  handleChange() {
    const selectedOption = [];

    this.querySelectorAll('input[type="radio"]:checked').forEach((radio) => {
      selectedOption.push(radio.value);
    });

    const exactMatchIndex = this.variants.findIndex((variant) => {
      return selectedOption.every((optionValue, index) => {
        return variant.options[index] === optionValue;
      });
    });

    let matchedVariant =
      exactMatchIndex !== -1 ? this.variants[exactMatchIndex] : null;

    if (!matchedVariant) {
      matchedVariant = this.getNextAvailableVariantForOption1(
        selectedOption[0],
        selectedOption[1],
      );
    }

    if (!matchedVariant) return;

    this.syncSelectorsToVariant(matchedVariant);
    console.log(matchedVariant);

    this.idInput.value = matchedVariant.id;
    this.updateURL(matchedVariant.id);
    this.updateVariants(matchedVariant.id, matchedVariant);
    this.updateSectionBelowFold(matchedVariant.id);
    this.updateModes(matchedVariant.name);
  }

  getNextAvailableVariantForOption1(option1, option2) {
    if (!option1 || !this.variants?.length) return null;

    const variantsForOption1 = this.variants.filter((variant) => {
      return variant?.available && variant?.options?.[0] === option1;
    });

    if (!variantsForOption1.length) return null;

    const currentOption2Index = variantsForOption1.findIndex((variant) => {
      return variant?.options?.[1] === option2;
    });

    if (currentOption2Index === -1) return variantsForOption1[0];

    const nextIndex = (currentOption2Index + 1) % variantsForOption1.length;
    return variantsForOption1[nextIndex];
  }

  syncSelectorsToVariant(variant) {
    if (!variant?.options?.length) return;

    variant.options.forEach((optionValue, optionIndex) => {
      if (!optionValue) return;

      const selector = this.querySelector(
        `input[type="radio"][data-index="${optionIndex + 1}"][value="${optionValue}"]`,
      );

      if (selector) selector.checked = true;
    });
  }

  updateModes(name) {
    document.documentElement.classList.remove(
      "sativa",
      "indica",
      "hybrid",
      "mixed",
    );

    if (name.toLowerCase().includes("indica")) {
      document.documentElement.classList.add("indica");
    } else if (name.toLowerCase().includes("hybrid")) {
      document.documentElement.classList.add("hybrid");
    } else if (name.toLowerCase().includes("mixed")) {
      document.documentElement.classList.add("mixed");
    } else {
      document.documentElement.classList.add("sativa");
    }
  }

  updateURL(variantId) {
    const url = new URL(window.location.href);
    url.searchParams.set("variant", variantId);
    window.history.pushState({}, "", url);
  }

  updateVariants(variantId, variant) {
    const quantitySelectorValue = document.querySelectorAll(
      ".quantity-selector__value",
    );
    quantitySelectorValue.forEach((value) => {
      value.textContent = 1;
    });
    const getUrl = new URL(window.location.href);
    let url = "";
    if (getUrl.searchParams.has("selling_plan")) {
      const sellingPlanId = getUrl.searchParams.get("selling_plan");
      url = `${window.location.pathname}?variant=${variantId}&selling_plan=${sellingPlanId}&section_id=${this.sectionId}`;
    } else {
      url = `${window.location.pathname}?variant=${variantId}&section_id=${this.sectionId}`;
    }
    document
      .querySelector(".product-gallery__loading")
      .classList.remove("hidden");

    fetch(url)
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        const newContent = new DOMParser().parseFromString(data, "text/html");

        //update product tabs
        if (this.hasTabsVariantMetafields) {
          const newContentProductTabs =
            newContent.querySelector("#product-tabs");
          if (newContentProductTabs) {
            document.querySelector("#product-tabs").innerHTML =
              newContentProductTabs?.innerHTML;
          } else {
            document.querySelector("#product-tabs").innerHTML = "";
          }
        }
        //update product labels
        if (this.hasLabelsVariantMetafields) {
          const newContentProductLabels =
            newContent.querySelector("#product-labels");
          const productLabelsMarkup = newContentProductLabels
            ? newContentProductLabels.innerHTML
            : "";
          document
            .querySelectorAll("#product-labels")
            .forEach((labelsElement) => {
              labelsElement.innerHTML = productLabelsMarkup;
            });
        }

        //update variants
        const newContentVariants =
          newContent.querySelector("#variant-selector");

        document.querySelector("#variant-selector").innerHTML =
          newContentVariants.innerHTML;

        //update product gallery
        const newContentProductGallery =
          newContent.querySelector("#product-gallery");

        document.querySelector("#product-gallery").innerHTML =
          newContentProductGallery.innerHTML;

        // Update Product Subscriptions Prices
        const newContentProductSubscriptionsPrices = newContent.querySelector(
          "#subscription_prices",
        );

        if (document.querySelector("#subscription_prices")) {
          document.querySelector("#subscription_prices").innerHTML =
            newContentProductSubscriptionsPrices.innerHTML;

          //update one time price
          const newContentProductOneTimePrices =
            newContent.querySelector("#one_time_price");

          document.querySelector("#one_time_price").innerHTML =
            newContentProductOneTimePrices.innerHTML;
        }
        // Update Product Atc Button
        const newContentProductAtcButton = newContent.querySelector(
          "#product-atc-button",
        );

        document.querySelector("#product-atc-button").innerHTML =
          newContentProductAtcButton.innerHTML;

        //Update Sticky ATC Button
        const newContentStickyAtcButton = newContent.querySelector(
          "[data-sticky-atc-button]",
        );

        document.querySelector("[data-sticky-atc-button]").innerHTML =
          newContentStickyAtcButton.innerHTML;

        const productMainPrice = document.querySelectorAll(
          "[data-product-main-price]",
        );
        const productMainPriceCompare = document.querySelectorAll(
          "[data-product-main-price-compare]",
        );
        const productPriceAll = document.querySelectorAll(
          "[data-product-price]",
        );
        const quantity = Number(
          document.querySelector("#quantity-selector__value").textContent,
        );

        if (document.querySelector("#subscription_prices")) {
          //update product prices
          const productPrice = document.querySelector("#product-price");

          const subsciptionChecked =
            document.querySelector("#subscriptions").checked;

          const subscriptionPrice = document.querySelector(
            "[data-subscription-price]",
          );
          const subscriptionComparePrice = document.querySelector(
            "[data-subscription-compare-price]",
          );
          const oneTimePrice = document.querySelector("[data-one-time-price]");
          const oneTimeComparePrice = document.querySelector(
            "[data-one-time-compare-price]",
          );
          const mainPriceOff = document.querySelectorAll(
            "[data-main-price-off]",
          );

          //Update add to
          if (productPrice) {
            if (subsciptionChecked) {
              productPrice.dataset.productPrice = document.querySelector(
                "#subscription_price",
              ).dataset.subscriptionPrice;
            } else {
              productPrice.dataset.productPrice = document.querySelector(
                "#one_time_price [data-one-time-price]",
              ).dataset.oneTimePrice;
            }

            productPriceAll.forEach((price) => {
              price.innerHTML = Shopify.customFormatMoney(
                productPrice.dataset.productPrice * quantity,
                "{{amount}}",
              );
            });
          }

          if (subsciptionChecked) {
            productMainPrice.forEach((price) => {
              price.textContent = Shopify.customFormatMoney(
                subscriptionPrice.dataset.subscriptionPrice,
                "{{amount}}",
              );
            });
            productMainPriceCompare.forEach((price) => {
              price.textContent = Shopify.customFormatMoney(
                subscriptionComparePrice.dataset.subscriptionComparePrice,
                "{{amount}}",
              );
            });
            mainPriceOff.forEach((price) => {
              price.style.display = "block";
            });
          } else {
            productMainPrice.forEach((price) => {
              price.textContent = Shopify.customFormatMoney(
                oneTimePrice.dataset.oneTimePrice,
                "{{amount}}",
              );
            });
            if (oneTimeComparePrice) {
              productMainPriceCompare.forEach((price) => {
                price.textContent = Shopify.customFormatMoney(
                  oneTimeComparePrice.dataset.oneTimeComparePrice,
                  "{{amount}}",
                );
              });
            } else {
              productMainPriceCompare.forEach((price) => {
                price.textContent = "";
              });
            }
            mainPriceOff.forEach((price) => {
              price.style.display = "none";
            });
          }
        } else {
          productMainPrice.forEach((price) => {
            price.textContent = Shopify.customFormatMoney(
              variant.price,
              "{{amount}}",
            );
          });
          productMainPriceCompare.forEach((price) => {
            if (variant.compare_at_price) {
              price.textContent = Shopify.customFormatMoney(
                variant.compare_at_price,
                "{{amount}}",
              );
            } else {
              price.textContent = "";
            }
          });

          productPriceAll.forEach((price) => {
            price.innerHTML = Shopify.customFormatMoney(
              variant.price * quantity,
              "{{amount}}",
            );
          });
        }
      })
      .catch((error) => {
        if (error.name !== "AbortError") {
          console.error("Error fetching variant:", error);
        }
      })
      .finally(() => {
        document
          .querySelector(".product-gallery__loading")
          .classList.add("hidden");
      });
  }
  updateSectionBelowFold(variantId) {
    const sectionId = this.legendsOnlySection.dataset.sectionId;

    const url = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;

    fetch(url)
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        const newContent = new DOMParser().parseFromString(data, "text/html");

        //update legends only section
        const newContentLegendsOnlySection = newContent.querySelector(
          "#legends-only-section",
        );

        document.querySelector("#legends-only-section").innerHTML =
          newContentLegendsOnlySection.innerHTML;
      })
      .catch((error) => {
        if (error.name !== "AbortError") {
          console.error("Error fetching variant:", error);
        }
      });
  }
}

customElements.define("variant-selector", VariantSelector);
